/* eslint @typescript-eslint/strict-boolean-expressions: off */

// Styling
import styles from "gui/UserPage/UserProfile/UserProfile.module.css";
import cn from "classnames";

// Components
import { Icon } from "gui/icon/icon";

// Utils
import { formatDateMY } from "lib/dates/dates";
import { formatNumber } from "lib/intl/number";

interface Props {
  receivedStarsCount: number;
  queriesCount: number;
  dashboardsCount: number;
  firstQueryCreatedDate: string | null;
  submittedContractsCount: number;
  className?: string;
}

export default function UserStats(props: Props) {
  return (
    <ul className={cn(styles.rightList, props.className)}>
      <li>
        <span>
          {formatNumber(props.receivedStarsCount)}{" "}
          {props.receivedStarsCount === 1 ? "star" : "stars"}
        </span>
        <Icon icon="star-fill" aria-hidden />
      </li>
      <li>
        <span>
          {formatNumber(props.queriesCount)}{" "}
          {props.queriesCount === 1 ? "query" : "queries"}
        </span>
        <Icon icon="terminal" aria-hidden />
      </li>
      <li>
        <span>
          {formatNumber(props.dashboardsCount)}{" "}
          {props.dashboardsCount === 1 ? "dashboard" : "dashboards"}
        </span>
        <Icon icon="dashboard" aria-hidden />
      </li>
      <li>
        <span>
          {formatNumber(props.submittedContractsCount)}{" "}
          {props.submittedContractsCount === 1 ? "contract" : "contracts"}
        </span>
        <Icon icon="list-nested" aria-hidden />
      </li>
      {props.firstQueryCreatedDate && (
        <li>
          <span>Wizard since {formatDateMY(props.firstQueryCreatedDate)}</span>
          <Icon icon="plant" aria-hidden />
        </li>
      )}
    </ul>
  );
}
